import { combineReducers } from "redux";

import archive from "./archive";
import boardFilter from "./boardFilter";
import habitsEntities from "./habitsEntities";
import groupsEntities from "./groupsEntities";
import user from "./user";
import dates from "./dates";
import basedate from "./basedate";
import modal from "./modal";
import banner from "./banner";
import promo from "./promo";
import errors from "./errors";
import queue from "./queue";
import variables from "./variables";
import rows from "./rows";
import controlPanel from "./controlPanel";

const allReducers = combineReducers({
  archive,
  boardFilter,
  habitsEntities,
  groupsEntities,
  user,
  dates,
  basedate,
  modal,
  banner,
  promo,
  errors,
  queue,
  rows,
  variables,
  controlPanel,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = action.state;
  }

  return allReducers(state, action);
};

export default rootReducer;
